import { on } from 'delegated-events'

const tourVideos = document.querySelectorAll('[data-tour-video]')

const BCM_Banner_Path = window.location.protocol + '//www.onlinebanktours.com'
const BCM_Looping = true

const fn = {
  init: () => {
    fn.setupScript()

    on('click', '[data-tour-video]', fn.handleVideo)
  },

  handleVideo: (e) => {
    e.preventDefault()

    const anchor = e.target.closest('[data-tour-video]')
    const key = anchor.dataset.tourVideo

    if (window.beavercreekmarketinglightbox && key) {
      window.beavercreekmarketinglightbox.returnFocusTo(anchor)
      window.beavercreekmarketinglightbox.setURL(
        `${BCM_Banner_Path}/external/v5/player.php?key=${key}&loop=${BCM_Looping}`
      )
    }
  },

  setupScript: () => {
    if (!document.getElementById('BCM_Light_Box_Script')) {
      var script = document.createElement('script')
      script.src = BCM_Banner_Path + '/external/v5/BCM_Light_Box.js'
      script.type = 'text/javascript'
      script.id = 'BCM_Light_Box_Script'
      document.getElementsByTagName('head')[0].appendChild(script)
    }
    if (!document.getElementById('BCM_Light_Box_Styles')) {
      var css = document.createElement('link')
      css.type = 'text/css'
      css.rel = 'stylesheet'
      css.href = BCM_Banner_Path + '/external/v5/BCM_Ad_Styles.css'
      css.id = 'BCM_Light_Box_Styles'
      document.getElementsByTagName('head')[0].appendChild(css)
    }
  },
}

export default {
  can: () => tourVideos.length,
  run: fn.init,
}
